import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  navigationItems = [
    {
      relativeUrl: '/manureSubstances',
      label: 'manureSubstances',
      icon: 'dashboard',
    },
    {
      relativeUrl: '/fertilization-legal-standards',
      label: 'legalStandardsReport',
      icon: 'list_alt',
    },
  ];
}
